enum BankTarget {
    CREDITO_REAL = 'credito-real',
    TURBO_CASH = 'turbo-cash',
    CREDITO_REAL_STATE = 'creditoReal',
    TURBO_CASH_STATE = 'turboCash'
}

enum EmploymentTypes {
    INDEPENDENT_ID = 'INDEPENDENT',
    INDEPENDENT_VALUE = 'Independiente',
    DEPENDENT_ID = 'DEPENDENT',
    DEPENDENT_VALUE = 'Asalariado'
}

export {
    BankTarget,
    EmploymentTypes
};